import type { GraphMode } from '@ipfabric/utils';
import type { GraphState } from 'components/Graph/GraphState';

export const selectGraphMode = (s: GraphState): GraphMode | null =>
  s.graphMetadata?.parameters.type ?? null;
